module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/9780062190581_Contents#c1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_vm._v("Or “(She) Got Me Bad”")]), _vm._v(" "), _c('p', {
    staticClass: "txf"
  }, [_vm._v("I wonder if we should start with the introductions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I know who you are. You’re the person reading this. For whatever reason, and in whatever place, that’s you, and soon we’ll be friends, and you’ll never ever convince me otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m Jason Priestley.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I know what you’re thinking. You’re thinking: Goodness! Are you the same Jason Priestley, born in Canada in 1969, famous for his portrayal of Brandon Walsh, the moral center of the hit American television series "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Beverly Hills 90210")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And the surprising answer to your very sensible question is no. No, I’m not. I’m the other one. I’m the thirty-two-year-old Jason Priestley who lives on the Caledonian Road, above a videogame shop between a Polish newsagents and that place that everyone "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("thought")]), _vm._v(" was a brothel, but wasn’t. The Jason Priestley who gave up his job as a deputy head of department in a bad North London school to chase a dream of being a journalist after his girlfriend left him but who’s ended up single and going to cheap restaurants and awful films so’s he can write about them in that free newspaper they give you on the tube that you take but don’t read.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Yeah. "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("That")]), _vm._v(" Jason Priestley.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m also the Jason Priestley with a problem.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see, just in front of me—right here, on this table, just in front of me—is a small plastic box. A small plastic box I’ve come to regard as a small plastic box that could "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("change")]), _vm._v(" things. Or, at least, make them "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("different")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And right now, I’d take different.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I don’t know what’s in this small plastic box, and I don’t know if I ever will. "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("That’s")]), _vm._v(" the problem. I "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("could")]), _vm._v(" know; I could have it open within the hour, and I could pore over its contents, and I could know once and for all whether there was any . . . "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("hope")]), _vm._v(" in there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But if I do, and it turns out there "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("is")]), _vm._v(" hope in there, what if that’s all it is? Just a bit of hope? And what if that hope turns to nothing?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Because the one thing I hate about hope—the one thing I "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("despise")]), _vm._v(" about it, that no one ever seems to "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("admit")]), _vm._v(" about it—is that suddenly having hope is the easiest route to sudden hopelessness there is.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And yet that hope is already within me. Somehow, without my inviting it in or expecting it in any way, it’s there, and based on what? Nothing. Nothing apart from the glance she gave me and the fleeting glimpse I got of . . . "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("something")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’d been standing on the corner of Charlotte Street when it happened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was maybe six o’clock, and a girl—because yeah, you and I both "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("knew")]), _vm._v(" there was going to be a girl; there "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("had")]), _vm._v(" to be a girl; there’s "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("always")]), _vm._v(" a girl—was struggling with the door of the black cab and the packages in her hands. She had a blue coat and nice shoes, and white bags with names I’d never seen before on them, and boxes, and even, I think, a cactus poking out the top of a Heal’s bag.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was ready to walk past, because that’s what you do in London, and to be honest, I nearly did . . . but then she nearly dropped the cactus. And the other packages all shifted about, and she had to stoop to keep them all up, and for a moment there was something sweet and small and helpless about her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then she uttered a few choice words I won’t tell you here in case your nan comes round and finds this page.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I stifled a smile, and then looked at the cabbie, but he was doing nothing, just listening to TalkSport and smoking, and so—and I don’t know why, because like I say, this is "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("London")]), _vm._v("—I asked if I could help.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And she smiled at me. This incredible smile. And suddenly I felt all manly and confident, like a handyman who knows "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("just")]), _vm._v(" which nail to buy, and now I’m holding her packages and some of her bags, and she’s shoveling new ones that seem to have appeared from nowhere into the cab, and she’s saying, “"), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Thank")]), _vm._v(" you, this is "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("so")]), _vm._v(" kind of you,” and then there’s that moment. The glance, the fleeting glimpse of that "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("something")]), _vm._v(" I mentioned. And it felt like a beginning. But the cabbie was impatient and the night air cold, and I suppose we were just too British to say anything else and then it was, “"), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Thanks")]), _vm._v(",” and that smile again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She closed the door, and I watched the cab move off, taillights fading into the city, hope trailing and clattering on the ground behind it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then—just as the moment seemed over—I looked down.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I had something in my hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A small plastic box.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I read the words on the front.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Single-Use 35mm Disposable Camera.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wanted to shout at the cab—hold the camera up and make sure she knew she’d left something behind. And for a second I was filled with ideas—maybe when she came running back, I’d suggest a coffee, and then agree when she said what she "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("really")]), _vm._v(" needed was a huge glass of wine, and then we’d get a bottle, because it made better financial sense to get a bottle, and then we’d agree we shouldn’t be drinking on empty stomachs, and then we’d jack in our jobs and buy a boat and start making cheese in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But nothing happened.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("No screech of car tire, no pause then crunch of gears, no reverse lights, no running, smiling girl in nice shoes and a blue coat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Just a new taxi stopping, so a fat man could get out at a cashpoint.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You see what I mean about hope?")]), _vm._v(" "), _c('p', {
    staticClass: "txft"
  }, [_vm._v("“Now, before we go any further whatsoever,” said Dev, holding up the cartridge and tapping it very gently with his finger. “Let’s talk about the name. ‘Altered Beast.’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I was staring at Dev in what I like to imagine was quite a blank manner. It didn’t matter. In all the years I’ve known him I doubt he’s seen many looks from me, other than my blank one. He probably thinks I’ve looked like this since university.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Now, it conjures up not only mysticism, of course, but also "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("intrigue")]), _vm._v(", meshing as it does both Roman culture "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("and")]), _vm._v(" Greek mythology.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I turned and looked at Pawel, who seemed mildly traumatized.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Now, the interesting thing about the sound effects—” said Dev, and he pressed a button on his keyring and out came a tinny, distorted noise that sounded as if it "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("might")]), _vm._v(" be trying to say, “"), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Wise fwom your gwaaave!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I put my hand up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, Jase, you’ve got a question?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Why’ve you got that noise on your keyring?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dev sighed, and made quite a show of it. “Oh, I’m sorry, Jason, but I’m "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("trying")]), _vm._v(" to tell Pawel here about the early development of Sega Mega Drive games in the late 1980s and early 1990s. I’m sorry we’re not covering your personal passion of the work of American musical duo Hall & Oates, but that’s not why Pawel is here, is it?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Pawel just smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Pawel does a lot of smiling when he visits the shop. It’s usually to collect money Dev owes him for his lunchtime snacks. I sometimes watch his face as he wanders around the floor, taking in ancient, faded posters of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Sonic 2")]), _vm._v(" or "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Out Run")]), _vm._v(", picking up chipped carts or battered copies of old magazines, flicking through the reviews of long-dead platformers or shoot-’em-ups that look like they were drawn by toddlers now. Dev let him borrow a Master System and a copy of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Shinobi")]), _vm._v(" the other day. Turns out you didn’t really get many Master Systems in mid-’80s Eastern Europe, and even less ninjas. We’re not going to let him borrow the Xbox, because Dev says his eyes might explode.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Anyway,” said Dev. “The name of this very shop—Power Up!—owes its existence to—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And I start to realize what Dev’s doing. He’s trying to "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("bore")]), _vm._v(" Pawel out of here. Dominate the conversation. Bully him into leaving, the way men with useless knowledge often do. Throw in phrases like, “Oh, didn’t you "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("know")]), _vm._v(" that?” or “Of course, you’ll "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("already")]), _vm._v(" be aware . . .” in order to patronize and thwart and win.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He can’t have enough cash on him for lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How much does he owe you, Pawel?” I asked, fishing for a fiver in my pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dev shot me a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "orb"
  }), _vm._v(" "), _c('p', {
    staticClass: "txf"
  }, [_vm._v("I love London.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I love everything about it. I love its palaces and its museums and its galleries, sure. But also, I love its filth, and damp, and stink. Okay, well, I don’t mean "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("love")]), _vm._v(", exactly. But I don’t mind it. Not anymore. Not now I’m used to it. You don’t mind anything once you’re used to it. Not the graffiti you find on your door the week after you painted over it, or the chicken bones and cider cans you have to move before you can sit down for your damp and muddy picnic. Not the ever-changing fast-food joints—AbraKebabra to Pizza the Action to Really Fried Chicken—and all on a high street that despite its three new names a week never seems to look any different. Its tawdriness can be comforting, its willfulness inspiring. It’s the London I see every day. I mean, tourists: they see the Dorchester. They see Harrods, and they see men in bearskins and Carnaby Street. They very rarely see the Happy Shopper on the Mile End Road, or a drab Peckham disco. They head for Buckingham Palace, and see waving above it the red, white, and blue, while the rest of us order dansak from the Tandoori Palace, and see Simply Red, White Lightning, and Duncan from Blue.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But we should be proud of that, too.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Or, at least, get used to it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You could find a little bit of Poland on one end of the Caledonian Road these days, the way you could find Portugal in Stockwell, or Turkey all through Haringey. Since the shops came, Dev has used his lunchtimes to explore an entirely new culture. He was like that at university when he met a Bolivian girl at Leicester’s number one nightclub, Boomboom. I was studying English, and for a month or so, Dev was studying Bolivian. Each night he’d dial up Internet and wait ten minutes for a single page to load, before printing it off and committing stock Spanish phrases to memory, hoping once again to bump into her, but never, ever managing it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Fate!” he’d say. “Ah, fate.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Now it was all about Poland. He gorges himself on "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("z szynka")]), _vm._v(" cheese, proclaiming it to be the finest cheese he’s ever tasted, ignoring the fact it’s processed and in little plastic packets and tastes "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("exactly")]), _vm._v(" like Dairylea. He buys "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("krokiety")]), _vm._v(" and "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("krupnik")]), _vm._v(" and more cheese, with bright pink synthetic ham pebble-dashed across each bland jaundiced slab. Once he bought a beetroot, but he didn’t eat it. Plus, if it’s the end of the day he’ll make sure whatever customer happens to still be there sees him with a couple of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("paczki")]), _vm._v(" and a goblet of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("jezynowka")]), _vm._v(". And once he’s made it obvious enough and they’ve asked what on "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("earth")]), _vm._v(" he’s got in his hands, he’ll say, “Oh, they’re brilliant. Haven’t you ever "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("had")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("paczki")]), _vm._v("?,” and then look all international and pleased with himself for a bit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But he’s not doing it to show off. Not really. He’s got a good heart, and I think he thinks he’s being welcoming and informative. It’s still the laziest form of tourism there is, though. No one else I know simply sits there, playing videogames, and waiting for the countries to come to him, with each new wave of what he likes to call the “Newbies.” He wants to see the world, he’ll tell you—but he prefers to see it all from the window of his shop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Men come from everywhere to shop here. Men trying to recapture their youth, or complete a collection, or find that one game they used to be brilliant at. There’s new stuff, sure—but that’s just to survive. That’s not why people come. And when they do, sometimes they get the Power Up! reference. After that, it’s only a matter of moments before Dev mentions Makoto Uchida, and that’s usually enough to establish his superiority and scare them off, maybe having bought a "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("£")]), _vm._v("2 copy of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Decap Attack")]), _vm._v(" or "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Mr. Nutz")]), _vm._v(", but probably not.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dev sells next to nothing, but next to nothing seems to be just enough. His dad owns a few restaurants on Brick Lane and keeps the basics paid, and what little extra there is keeps Dev in ham-flecked "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("z szynka")]), _vm._v(", at any rate. Plus he’s been good to me, so I shouldn’t judge him. I lost a girlfriend and a flat but gained a flatmate and virtually no rent in return for a few afternoon shifts and a weekly supply of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("krokiety")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Talking of which . . .")]), _vm._v(" "), _c('p', {
    staticClass: "txft"
  }, [_vm._v("“Right, we’ve got "), _c('span', {
    staticClass: "size"
  }, [_c('img', {
    staticClass: "resize",
    attrs: {
      "alt": "",
      "src": "Images/symbol.png"
    }
  })]), _vm._v("ubr or "), _c('span', {
    staticClass: "size"
  }, [_c('img', {
    staticClass: "resize",
    attrs: {
      "alt": "",
      "src": "Images/symbol.png"
    }
  })]), _vm._v("ywiec—take your pick!” said Dev, holding up the bottles. I wasn’t sure I could pronounce either of them so pointed at the one with the least letters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Or I think I’ve got some Lech somewhere,” he said, pronouncing it “Letch” and then giggling. Dev knows it’s pronounced “Leck,” because he asked Pawel, but he prefers saying “Letch” because it means he can giggle afterward.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“"), _c('span', {
    staticClass: "size"
  }, [_c('img', {
    staticClass: "resize",
    attrs: {
      "alt": "",
      "src": "Images/symbol.png"
    }
  })]), _vm._v("ubr is fine,” I said—something I’d never said before—and he flipped the lid and passed it over.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I caught sight of myself in the mirror behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I looked tired.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Sometimes I look at myself and think, Is this it?, and then I think, Yes, it is. This is literally the best you will ever look. Tomorrow, you will look just a little bit worse, and this is how it will go, forever. You should definitely buy some Berocca.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I have the haircut of the mid-thirties man. Until recently, I wore cool, ironic T-shirts, until I realized the real irony was they made me look less cool.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’m too old to experiment with my hair, see, but too young to have found the style I’ll take to the grave. You know the one I mean—the one we’re all headed for, if we’re lucky enough to have any left by then. Flat and dulled and sitting on every man in an oversized shirt at an all-inclusive holiday resort breakfast buffet, surrounded by unpleasant children and a passive-aggressive wife who have worked together in single-minded unity to quash his ambitions the way they have quashed his hairstyle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I say that like I’m any better, or that my ambitions are heroic and worthy. I am a man between styles, is all, and there are millions of me. I’m at that awkward stage between the man of his twenties and the man of his forties. A stage I have come to call “the man in his thirties.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I sometimes wonder what the caption at the bottom of my "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Vanity Fair")]), _vm._v(" shoot would say, the day I wrote the cover story and they decided to make a big deal of me:")]), _vm._v(" "), _c('p', {
    staticClass: "exf"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Hair")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("by Angela at Toni & Guy, near Angel tube, even though her fingers smell of nicotine and she says “ax” instead of “ask.”")])]), _vm._v(" "), _c('p', {
    staticClass: "exm"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Smell:")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lynx Africa (for men). £2.76, Tesco Metro, Charing Cross.")])]), _vm._v(" "), _c('p', {
    staticClass: "exm"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Watch:")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Swatch.")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(“It was an impulse buy at Geneva airport,” he confides, laughing lightly, and picking at his salade Niçoise. “Our plane was three hours delayed and I’d already bought a Toblerone!”)")])]), _vm._v(" "), _c('p', {
    staticClass: "exl"
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Clothes:")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Model’s own")]), _vm._v(" "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("(with thanks to Topman VIP 10% discount card, available free to literally everyone in the world).")])]), _vm._v(" "), _c('p', {
    staticClass: "txf"
  }, [_vm._v("But I’m not that bad. A Spanish model I met at a Spanish bar on Hanway Street and once even had a passable date with said I looked “very English,” which I took to mean like Errol Flynn, even though later I found out he was Australian.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What. A. Day,” said Dev, sighing a little too heavily for a man who can’t really have had that much of a day. “You? Yours?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yeah,” I said. “You know, not bad,” by which I meant the opposite.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It had been bad from the moment I’d got up this morning. The milk had been off, but how’s that different from normal, and the postman had slammed and clattered our letterbox, but the real kicker was when, with a grim tightening of my stomach, I’d flicked my laptop on, and headed for Facebook, and even though I "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("knew")]), _vm._v(" something like this would eventually happen, I saw those words, the words I "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("knew")]), _vm._v(" would come.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v(". . . "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("is having the time of her life.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Seven words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A status update.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And next to it, Sarah’s name, so easily clickable.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And so I’d clicked it. And there she was. Having the time of her life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Stop, I’d thought. Enough now. Get up, have a shower.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("So I’d clicked on her photos.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She was in Andorra. With Gary. Having the time of her fucking life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’d snapped the laptop shut.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Didn’t she care that I’d see this? Didn’t she realize that this would go straight to my screen, straight to my stomach? These photos . . . these snapshots . . . taken from the point of view and angle "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("I")]), _vm._v(" used to see her from. But now it’s not "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("me")]), _vm._v(" behind the camera. It’s not "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("me")]), _vm._v(" capturing the moment. These memories aren’t "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("mine")]), _vm._v(". So I don’t want them. I don’t "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("want")]), _vm._v(" to see her, tanned and happy and sleeveless. I don’t "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("want")]), _vm._v(" to see her across a table with a cocktail and a look of joy and love and laughter on her face. I don’t "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("want")]), _vm._v(" to search for and take in the tiny, pointless, hurtful details—they’d shared a Margherita, the curls of her hair had lightened in the sun, she’d stopped wearing the necklace I gave her—I didn’t want "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("any")]), _vm._v(" of it. But I’d opened up the laptop again and I’d looked again anyway, pored over them, took in "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("everything")]), _vm._v(". I hadn’t been able to help it. Sarah was having the time of her life, and I was . . . well. What?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’d looked to see what "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("my")]), _vm._v(" last update had been.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jason Priestley is . . . "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("eating some soup.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Jesus. What a catch. Hey, Sarah, I know you’re off having the time of your life and all, but let’s not forget that only last Wednesday I was eating some soup.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Why didn’t I just delete her? Take her out of the equation? Make the Internet safe again? Same reason there was still a picture of her in my wallet. The one of her on her first day at work—all big blue eyes and Louis Vuitton. I’d not been strong enough to rip it up or bin it. It seemed so . . . final. Like giving up, or something. But here’s the thing: deep down, I knew one day "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("she’d")]), _vm._v(" delete "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("me")]), _vm._v(". And then that really would be it, and it wouldn’t be my decision, and then I’d be screwed. Part of me hoped that she wouldn’t—that somewhere, in that bag of hers, the one full of makeup and "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Grazia")]), _vm._v(" and Kleenex, somewhere in that bag would be a photo of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("me")]), _vm._v(" . . .")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And yeah, there’s that hope again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But then one day it’ll be cruelly and casually crushed and I’ll be forgotten, probably just before she decides that she and Gary should move in together, or she and Gary should get hitched, or she and Gary should make another, tiny Gary, which they’ll call Gary, and who’ll look exactly like bloody Gary.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I’ll probably be sitting there, on my own, when she finally deletes me. In a gray room with a Paddington duvet above a videogame shop next to that place that everyone "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("thought")]), _vm._v(" was a brothel, but wasn’t. A momentary afterthought, if that. Staring at a screen that informs me I can no longer obsess over her life. That I’m no longer deemed worthy of seeing her photos, seeing who her friends are, finding out when she’s hungover, or sleepy, or late for work. That "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("she’s")]), _vm._v(" no longer interested in finding out when "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("I’m")]), _vm._v(" eating soup.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Deleted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Misery.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Still. Could be worse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We could have run out of "), _c('span', {
    staticClass: "size"
  }, [_c('img', {
    staticClass: "resize",
    attrs: {
      "alt": "",
      "src": "Images/symbol.png"
    }
  })]), _vm._v("ubr.")]), _vm._v(" "), _c('p', {
    staticClass: "txft"
  }, [_vm._v("An hour later, and we’d run out of "), _c('span', {
    staticClass: "size"
  }, [_c('img', {
    staticClass: "resize",
    attrs: {
      "alt": "",
      "src": "Images/symbol.png"
    }
  })]), _vm._v("ubr.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dev had suggested the Den—a tiny Irish pub next to the tool hire shop, halfway down to King’s Cross—and I’d said yeah, why not. You never know. I might have the time of my life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Ah, listen,” said Dev, waving one hand in the air. “Who wants to go to Andorra anyway? What’s so good about Andorra?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Pogues were on and we were now a little drunk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The scenery. The tax-free shopping. The fact that it has two heads of state, those being the King of France and a Spanish bishop.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A pause.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’ve been on Wikipedia, haven’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“"), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Is")]), _vm._v(" there a King of France?” asked Dev.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“President, then, I can’t remember. All I know is it’s somewhere you go and have the time of your life. With a man called Gary, just before you have a pride of little Garys—all of whom will look like tiny thuggish babies—and then you buy a boat and make cheese in the country.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What are you "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("talking")]), _vm._v(" about?” said Dev.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Sarah.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Is she having tiny thuggish babies?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Probably,” I slurred. “Probably right now she’s just popped another one out. They’ll take over the world, her thuggish babies. They’ll spread and multiply, like in "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Arachnophobia")]), _vm._v(". They’ll stick to people’s faces and pound them with their little fists.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dev considered my wise words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You didn’t used to be like this,” he said. “Where did you go? Who’s this grumpy man?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It is me,” I said. “I am Mr. Grumpy. I called home last week and Mum was like, ‘You never come back to Durham, why do you never come home to Durham?’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So why do you never go back to Durham?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Because it’s a reminder, isn’t it? Of going backward. Anyway, Sarah doesn’t have that problem. She’s gonna have tiny thuggish babies.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I don’t think she’ll have thuggish babies. I thought Gary was, like, an investment banker?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Doesn’t mean he’s not gonna have thuggish babies,” I said, pointing my finger in the air to show I would not accept any form of contradiction on this. “He’s "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("exactly")]), _vm._v(" the type of man to have a thuggish baby. A little skinhead one. Who’s always shouting.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“But that’s just a "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("baby")]), _vm._v(",” said Dev.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Whatever,” I said. “Just don’t feed one of them after midnight.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a brief silence. An AC/DC track came on. My favorite. “Back in Black”—the finest rock song of its time. I was momentarily cheered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Let’s have another pint,” I said. “A "), _c('span', {
    staticClass: "size"
  }, [_c('img', {
    staticClass: "resize",
    attrs: {
      "alt": "",
      "src": "Images/symbol.png"
    }
  })]), _vm._v("ubr! Or a Zyborg!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But Dev was looking at me, very seriously now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You should delete her,” he said, flatly. “Just delete her. Be done with it. Leave Mr. Grumpy behind, because Mr. Grumpy is in danger of becoming Mr. Dick. I’m no expert, but I’m sure that’s what they’d say on "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("This Morning")]), _vm._v(", if you phoned up and asked one of those old women who solve problems.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I know,” I said, sadly.")]), _vm._v(" "), _c('p', {
    staticClass: "orb"
  }), _vm._v(" "), _c('p', {
    staticClass: "txf"
  }, [_vm._v("“These are 2,000 calories!” said Dev. “2,000! I read about it in the paper!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You read about it in "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("my")]), _vm._v(" paper,” I said. After several pints in the Den, we’d had the “one we came for” and stopped at Oz’s for a kebab on the way home. “I’m the one who showed it to you and said, ‘Read this! It says kebabs are 2,000 calories!’ ”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Wherever I read it, I’m just saying, 2,000 calories is a lot of calories for a kebab. But they’re good for you, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How are they "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("good")]), _vm._v(" for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They line your stomach with fat, so that when the apocalypse comes, you are better prepared. We’ll survive longer. Tubby people will inherit the earth!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Dev made a little “yahoo!” sound, but then started coughing on his chili sauce. He’s a little obsessed with the apocalypse, through years of roaming postapocalyptic landscapes, scavenging for objects and fighting giant beetles in videogames, which he genuinely regards as his “important training.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Right now, he was having trouble getting the key into the door. You’d lose points for that in an apocalypse. You’d also lose points for wearing glasses, but they’re an important part of Dev. He has an IQ of around 146 according not just to a psychiatrist when he was four but also to some interactive quiz he did on the telly, which makes me proud of him when I’m drunk, though you’d never think it was anywhere "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("close")]), _vm._v(" to 146 to speak to him. He has applied for four of the however-many-seasons of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Apprentice")]), _vm._v(" there’ve been, but for some reason they are yet to reply satisfactorily to this part-owner of a very minor secondhand videogame shop on the Caledonian Road, which I would find funny, if I didn’t know this actually broke his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It’d be easy to argue that Dev was defined at fourteen. His interests, his way with girls, even his look. See, when Dev was fourteen, his grandfather died, and that had a huge impact on his life. Not because it was emotionally traumatic, though of course it was, but because Dev’s dad doesn’t like to see money wasted. And the year before, Dev had started to notice he wasn’t like the other kids. Just small things—not being able to see a sign, not being able to read a clock, and persistently and with great flair falling out of his bed. He was short-sighted.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His dad is a businessman. His dad thought, why pay for frames, when a pair of frames was clearly so nearly ready and available for no money whatsoever?")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And so Dev had been given his granddad’s frames. His "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("granddad’s")]), _vm._v(". Literally three days after the funeral. Relensed, obviously, but by his dad’s mate, on the Whitechapel Road, and with cheap, scuffable plastic. Dev went through the next four years ridiculed by all and sundry for having a young boy’s face and an old man’s pair of specs, like a toddler wearing his mum’s sunglasses. He tried to grow a mustache to compensate, but that just made him look like a miniature military dictator.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And he’d never bought a new pair. Why should he? He’d found his look. And these days, it was working to his advantage. At university, at least at first, it had been considered odd, these thick black frames on a weird new kid, but they were a comfort blanket in year one, an eccentricity or quirk in year two, and, he hoped, a chick magnet in year three.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("(They weren’t.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But later, when you added them to the hair he couldn’t be bothered to get cut and the T-shirts he either got for free or bought from eBay for a pound and a penny, these glasses screamed confidence. These glasses screamed . . . well, they screamed “Dev.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Foreign girls, who couldn’t understand him but liked bright jackets, thought he looked cool.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Come on!” he said, finally through the door and slamming the banister with his fist as we stumbled upstairs. “I know what’ll cheer you up.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In the flat, Dev threw his kebab onto the table and made for the kitchen, where he started to go through cupboards and loudly shift stuff about.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wandered into my bedroom and picked up my laptop and made a determined face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Maybe I "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("should")]), _vm._v(" do it, I thought. Just delete her. Move on. Forget about things. Be the grown-up. It’d be easy. And then I could turn on my computer without that low, dull ache. That anticipation of maybe seeing something bad. I could get on with my life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I heard Dev shout, “Aha!” as I fired up the Internet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Found it, Jase! Prime bottle of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("jezynowka")]), _vm._v("! Blackberry brandy! How’s about we hook up the N64 and drink "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("jezynowka")]), _vm._v(" and play "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("GoldenEye")]), _vm._v(" till dawn?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I wasn’t listening. Not really. I was only guessing at what he was saying. He could have been knocking over vases and composing racist songs for all I knew, because I was transfixed, and shocked, and I don’t know what else, by what I saw on the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One word this time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One word that kicked me in the teeth and stamped on my hope and made fun of my family.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Jase?” said Dev, suddenly there, in my doorway. “D’you want to be James Bond or Natalia?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But I didn’t look round.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("My eyes were pricked with tears and I could feel every hair on my body, because all I could see were the words “Sarah Bennett is . . .” and then that last one, that killer, that complete and absolute "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("bastard")]), _vm._v(" of a word.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c12ac7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9780062190581_One.vue
// module id = 75
// module chunks = 0